import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Navigation } from "./components/Navigation";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { FormSubmissionPage } from "./pages/FormSubmissionPage";
import { SubmissionDetailsPage } from "./pages/SubmissionDetailsPage";
import { ExternalFormPage } from "./pages/ExternalFormPage";
import { AdminPage } from "./pages/AdminPage";
import {
  ProtectedRoute,
  RoleProtectedRoute,
} from "./components/ProtectedRoute";
import "./styles/index.css";

// Componente interno que puede usar useLocation (dentro del Router)
const AppContent = () => {
  const location = useLocation();
  // En rutas /form/:token no se muestra la barra de navegacion
  const hideNav = location.pathname.startsWith("/form/");

  return (
    <>
      {!hideNav && <Navigation />}
      <Routes>
        <Route path="/login" element={<Login />} />
        {/* Ruta publica para el solicitante externo (sin auth, sin nav) */}
        <Route path="/form/:token" element={<ExternalFormPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/form-submission"
          element={
            <RoleProtectedRoute allowedRoles={["referente", "usuario"]}>
              <FormSubmissionPage />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/submission/:submissionId"
          element={
            <ProtectedRoute>
              <SubmissionDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <RoleProtectedRoute allowedRoles={["secretaria"]}>
              <AdminPage />
            </RoleProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
